(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["micasa-set-components"] && !Shopify.designMode) return;
  try {
    document.addEventListener('product-ajax:added', function () {
    var uids = document.querySelectorAll('input[name*="[properties][__uid]"]');
    var newUid = Date.now();
    uids.forEach(function (input) {
      input.value = newUid;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
